import {
    UNABLE_TO_UPDATE_INFORMATION_ERROR_MESSAGE,
    CANNOT_UPDATE_UNLESS_ASSIGNED_ERROR_MESSAGE,
} from './constants';

export function getDisabledMessage(
    isError: boolean,
    isUnassignedUnit: boolean
): string | undefined {
    if (!isError && !isUnassignedUnit) {
        return;
    }

    if (isError) {
        return UNABLE_TO_UPDATE_INFORMATION_ERROR_MESSAGE;
    }

    return CANNOT_UPDATE_UNLESS_ASSIGNED_ERROR_MESSAGE;
}
